let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aq7Lk")).then(() => parcelRequire('bq6h7'));